// init locales before component imports
import './init-locales';

import React from 'react';
import ReactDOM from 'react-dom';

import { initializeErrorTracking } from '@portal/common/services/error-tracking';
import { GoogleAnalyticsProvider } from '@portal/common/services/google-analytics';
import { StorageProvider, localStorageAdapter } from '@portal/common/services/local-storage';
import { withProfiler } from '@portal/common/services/sentry';
import { MediaProvider, ThemeProvider } from '@portal/common/theme';

import Root from './components/Root';
import config from './config';
import defaultTheme from './theme/theme-config';

initializeErrorTracking(config.sentryDsn, config.logRocketDsn);

const App = withProfiler(() => (
    <ThemeProvider theme={defaultTheme}>
        <MediaProvider>
            <StorageProvider
                version={config.storageCacheVersion}
                storageAdapter={localStorageAdapter}
            >
                <GoogleAnalyticsProvider
                    googleAnalyticsId={config.googleAnalyticsId}
                    debug={config.googleAnalyticsDebug}
                >
                    <Root />
                </GoogleAnalyticsProvider>
            </StorageProvider>
        </MediaProvider>
    </ThemeProvider>
));

ReactDOM.render(<App />, document.getElementById('root'));
